import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
	Theme,
	createStyles,
	WithStyles,
	withStyles,
	Card,
	CardContent,
	Grid,
	Typography,
	Button,
	Tabs,
	Tab,
	FormControlLabel,
	Checkbox,
	RadioGroup,
	Radio,
	FormGroup,
} from '@material-ui/core';
import {
	MyPATDialog,
	MyPATTextField,
	MyPATTextArea,
} from '../../common';
import TagManagementHeader from './TagManagementHeader';
import TagInfoCard from './TagInfoCard';
import TagPreview from './TagPreview';

import ContentTagsActions from '../actions/ContentTagsActions';
import CourseTagsActions from '../actions/CourseTagActions';
import { TagTypesBody } from '../types/TagTypesBody';
import { ContentTagsBody } from '../types/ContentTagsBody';
import { CourseTagsBody } from '../types/CourseTagsBody';
import { ContentTypeData } from '../types/ContentTypeData';
import ContentTypeActions from '../actions/ContentTypeActions';
import contentTagsServices from '../services/contentTagsServices';
import courseTagsServices from '../services/courseTagsServices';
import ACLService from '../../acl/services/aclService';
import { toggleLicenseExpiredDialog, setLoggedInUser } from "../../login/actions/userActions";

const styles = (theme: Theme) => createStyles({
	addTagBtn: {
		background: '#FFFFFF',
		border: '1px solid #DDDDDD',
		boxSizing: 'border-box',
		borderRadius: 4
	},

	card: {
		background: '#FFFFFF',
		border: '1px solid #E1E1E1',
		boxSizing: 'border-box',
		borderRadius: 5,
		boxShadow: 'none'
	},

	contentHeading: {
		fontFamily: 'Nunito',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: 20,
		color: '#333333'
	},

	cardContainer: {
		border: '1px solid #E1E1E1',
		borderRadius: 4
	},

	cardContentRoot: {
		...theme.mixins.gutters(),
		paddingTop: 20,
		paddingBottom: theme.spacing.unit * 2,
		'&:last-child': {
			paddingBottom: theme.spacing.unit * 2,
		},
	},

	mb1x: {
		marginBottom: theme.spacing.unit,
	},
	marginSM: {
		margin: '6px -6px -7px'
	},
	textRight: {
		textAlign: 'right',
	},
	mr1x: {
		marginRight: theme.spacing.unit,
	},
	mr2x: {
		marginRight: theme.spacing.unit * 2,
	},

	cardContent: {
		padding: 16,
		"&:last-child": {
			paddingBottom: 16
		}
	},

	subtitleFont: {
		fontFamily: 'Nunito',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: 16,
		lineHeight: '20px',
		color: '#666666'
	},

	tabRoot: {
		textAlign: 'left',
		minWidth: 'auto',
		'&:first-child': {
			paddingLeft: 0,
		},
	},

	tabLabelContainer: {
		padding: 0,
		'& > span': {
			color: 'rgba(51, 51, 51, 0.87)',
			fontSize: 20,
			fontWeight: 600
		}
	},

	tabIndicator: {
		height: 0,
	},

	optionLength: {
		width: theme.spacing.unit * 10,
		marginRight: theme.spacing.unit * 2,
	},

	tagTitle: {
		fontFamily: 'Nunito',
		fontStyle: 'normal',
		fontWeight: 600,
		fontSize: 20,
		lineHeight: '20px',
		color: '#333333',
		textTransform: "capitalize"
	},

	widthFit: {
		width: 'fit-content'
	}
});

const defaultTagFormData: ContentTagsBody | CourseTagsBody = {
	isCompulsory: ACLService.checkModulePermission("tag", "createMandatory"),
	isVisible: true,
	desc: "",
	name: "",
	typeName: "",
	content: {
		type: "",
		data: [],
	},
	contentTypes: [],

};

interface TagManagementContainerProps extends WithStyles<typeof styles> {
	contentTagTypesList: () => void,
	courseTagTypesList: () => void,
	contentTagsList: (limit: number, skip: number) => void,
	courseTagsList: (limit: number, skip: number) => void,
	contentTypeList: () => void,
	contentTagTypes: TagTypesBody[],
	courseTagTypes: TagTypesBody[],
	contentTags: ContentTagsBody[],
	courseTags: CourseTagsBody[],
	contentTypes: ContentTypeData[],
	isPostExpiryDays: any,
	showLicenseExpiredDialog: any,
	toggleLicenseExpiredDialog: any,
	setLoggedInUser: any,
}

interface TagManagementContainerState {
	searchValue: string,
	tagTypeDialogOpen: boolean,
	tagFormDialogOpen: boolean,
	isTagForTypeContent: boolean,
	tagFormData: ContentTagsBody | CourseTagsBody,
	tabValue: string,
	edit: boolean,
	dataLength: number,
	coursePageSkip: number,
	contentPageSkip: number,
	limit: number,
	scrollPosition: any,
	tagNameError: string,
	showTooltip: boolean 
}

class TagManagementContainer extends Component<TagManagementContainerProps, TagManagementContainerState> {
	constructor(props: TagManagementContainerProps) {
		super(props);
		this.state = {
			searchValue: '',
			tagTypeDialogOpen: false,
			tagFormDialogOpen: false,
			isTagForTypeContent: false,
			tagFormData: defaultTagFormData,
			tabValue: 'course',
			edit: false,
			dataLength: 1,
			contentPageSkip: 0,
			coursePageSkip: 0,
			limit: 10,
			scrollPosition: "",
			tagNameError: "",
			showTooltip: false
		};

		this.handleSearchChange = this.handleSearchChange.bind(this);
		this.handleTagTypeDialogOpen = this.handleTagTypeDialogOpen.bind(this);
		this.handleTagTypeDialogClose = this.handleTagTypeDialogClose.bind(this);

		this.handleAddTagFormDialogOpen = this.handleAddTagFormDialogOpen.bind(this);
		this.handleAddTagFormDialogClose = this.handleAddTagFormDialogClose.bind(this);

		this.handleTabChange = this.handleTabChange.bind(this);

		this.listenToTagScroll = this.listenToTagScroll.bind(this);
	}

	componentDidMount() {
		const { limit } = this.state;
		let skip = 0;
		_.isEmpty(this.props.contentTagTypes) && this.props.contentTagTypesList();
		_.isEmpty(this.props.courseTagTypes) && this.props.courseTagTypesList();
		_.isEmpty(this.props.contentTags) && this.props.contentTagsList(limit, skip);
		_.isEmpty(this.props.courseTags) && this.props.courseTagsList(limit, skip);
		_.isEmpty(this.props.contentTypes) && this.props.contentTypeList();
		window.addEventListener('scroll', (e) => this.listenToTagScroll(e));
		this.props.setLoggedInUser();
	}

	handleSearchChange = (evt: any) => this.setState({ searchValue: evt.target.value });

	handleTagTypeDialogOpen = () => this.setState({ tagTypeDialogOpen: true });
	handleTagTypeDialogClose = () => this.setState({ tagTypeDialogOpen: false });

	handleAddTagFormDialogOpen = (type: string, title: string) => {
		if(this.props.isPostExpiryDays){
			this.props.toggleLicenseExpiredDialog(true);
		} else {
			this.setState({
				tagFormDialogOpen: true,
				tagFormData: {
					...defaultTagFormData,
					isCompulsory: ACLService.checkModulePermission("tag", "createMandatory"),
					typeName: title,
					content: {
						type,
						data: [],
					}
				},
				tagNameError: "",
			})
		}
	};

	handleEditTagFormDialogOpen = (id?: string) => {
		if(this.props.isPostExpiryDays){
			this.props.toggleLicenseExpiredDialog(true);
		} else {
			let tagInfoFromStore: any = _.isEqual(this.state.tabValue, 'content') ? this.props.contentTags : this.props.courseTags;
			tagInfoFromStore = _.find(tagInfoFromStore, ['_id', id]);
			const dataLength = tagInfoFromStore.content.data ? tagInfoFromStore.content.data.length : 0;
			this.setState({ tagFormData: tagInfoFromStore, isTagForTypeContent: _.isEqual(this.state.tabValue, 'content'), edit: true, dataLength });
			return this.setState({ tagFormDialogOpen: true });
		}
	}

	handleAddTagFormDialogClose = () => {
		this.setState({
			tagFormData: defaultTagFormData,
			tagFormDialogOpen: false,
			isTagForTypeContent: false,
			edit: false,
			dataLength: 0,
		});
	}

	handleTabChange = (evt: any, value: string) => this.setState({ tabValue: value });
	handleTagFormForChange = (evt: any, value: string) => this.setState({ isTagForTypeContent: _.isEqual(value, 'content') });
	handleTagShouldChange = (evt: any, value: string) => this.setState({ tagFormData: { ...this.state.tagFormData, isCompulsory: _.isEqual(value, 'mandatory') } });

	handleContentTypeChange = (value: string, evt: any, checked: boolean) => {
		let { tagFormData }: any = this.state;
		if (checked) {
			tagFormData.contentTypes.push(value);
		} else {
			tagFormData.contentTypes.splice(tagFormData.contentTypes.indexOf(value), 1);
		}
		return this.setState({ tagFormData });
	}

	handleTagFormInputChange = (evt: any) => {
		let { tagFormData }: any = this.state;
		tagFormData[evt.target.name] = evt.target.value;
		return this.setState({ tagFormData });
	}

	handleTagFormOptionsChange = (evt: any) => {
		let { tagFormData } = this.state;
		let length = evt.target.value;
		// check to restrict min value should not be negative or not be zero
		length = (_.includes(length, '-') || _.isEqual(length, '0')) ? 1 : length;
		tagFormData.content.data.length = length;
		return this.setState({ dataLength: length, tagFormData });
	};

	handleTagFormOptionInputChange = (index: number, evt: any) => {
		let { tagFormData } = this.state;
		tagFormData.content.data[index] = evt.target.value;
		this.setState({ tagFormData });
	}

	handleTagFormTextLengthChange = (evt: any) => {
		let { tagFormData } = this.state;
		let length = evt.target.value;
		// check to restrict min value should not be negative or not be zero
		length = (_.includes(length, '-') || _.isEqual(length, '0')) ? 1 : length;
		tagFormData.content.textLength = length;
		this.setState({ tagFormData });
	}

	handleSaveSuccess = (res?: any) => {
		if (Object.keys(res).length > 0) {
			location.reload();
		}
	}
	handleAddTagFormSave = (evt: any) => {
		let { tagFormData, isTagForTypeContent, edit }: any = this.state;
		if (tagFormData.name == '') {
			this.setState({ tagNameError: 'Tag name required' }, () => {
				//@ts-ignore
				document.getElementById('name').focus();
			});
			return '';
		}
		if (isTagForTypeContent) {
			if (edit) {
				return contentTagsServices.update(tagFormData, tagFormData._id)
					.then((res: any) => this.handleSaveSuccess(res));
			} else {
				return contentTagsServices.create(tagFormData)
					.then((res: any) => this.handleSaveSuccess(res));
			}
		} else {
			if (edit) {
				courseTagsServices.update(tagFormData, tagFormData._id)
					.then((res: any) => this.handleSaveSuccess(res));
			} else {
				courseTagsServices.create(tagFormData)
					.then((res: any) => this.handleSaveSuccess(res));
			}
		}
	}

	listenToTagScroll = (e: any) => {
		let { coursePageSkip, contentPageSkip, limit, tabValue } = this.state;
		const { contentTagsList, courseTagsList, contentTags, courseTags } = this.props;

		if (tabValue == 'content') {

			let elemCT = document.getElementsByClassName('ctClass');
			if (_.isEmpty(elemCT)) { return; }
			const bounding = elemCT[elemCT.length - 1].getBoundingClientRect();
			const scrollPosition: any = window.pageYOffset || document.documentElement.scrollTop ? window.pageYOffset : 0;

			if (window.innerHeight > bounding.bottom && scrollPosition > this.state.scrollPosition && (limit * (contentPageSkip + 1) == contentTags.length)) {
				contentPageSkip = contentPageSkip + 1;

				contentTagsList(limit, contentPageSkip);
				this.setState({ contentPageSkip })
			}

			this.setState((state, props) => ({
				scrollPosition
			}));
		}
		else {
			let elemCRT = document.getElementsByClassName('crsClass');
			if (_.isEmpty(elemCRT)) { return; }
			const bounding = elemCRT[elemCRT.length - 1].getBoundingClientRect();
			const scrollPosition: any = window.pageYOffset || document.documentElement.scrollTop ? window.pageYOffset : 0;

			if (window.innerHeight > bounding.bottom && scrollPosition > this.state.scrollPosition && (limit * (coursePageSkip + 1) == courseTags.length)) {
				coursePageSkip = coursePageSkip + 1;

				courseTagsList(limit, coursePageSkip);
				this.setState({ coursePageSkip })
			}

			this.setState((state, props) => ({
				scrollPosition
			}));
		}
	}

	handleHover = () => {
		this.setState({
			showTooltip: !this.state.showTooltip
		})
	}

	render() {
		const {
			classes,
			contentTagTypes,
			contentTags,
			courseTags,
			contentTypes,
		} = this.props;
		const {
			searchValue,
			tagTypeDialogOpen,
			tagFormData,
			isTagForTypeContent,
			tagFormDialogOpen,
			tabValue,
			edit,
			showTooltip
		} = this.state;
		let { dataLength } = this.state;
		if (!dataLength) {
			dataLength = 1
		}
		const otherDialogProps = {
			fullWidth: true,
			maxWidth: 'md',
			scroll: 'body'
		};

		const getTextFields = (dataLength: number) => {
			let fields: any = [];
			for (let i = 0; i < dataLength; i++) {
				fields.push(
					<MyPATTextField
						key={`option-${i}`}
						placeholder={`Option ${i + 1}`}
						className={classes.mr1x}
						value={tagFormData.content.data[i] || ''}
						onChange={this.handleTagFormOptionInputChange.bind(this, i)}
					/>
				)
			}
			return fields;
		}

		return (
			<>

				<TagManagementHeader
					searchValue={searchValue}
					searchChangeHandler={this.handleSearchChange.bind(this)}
					addTagHandler={this.handleTagTypeDialogOpen.bind(this)}

				/>

				<Grid container justify="center" >
					<Grid item xs={12} md={10}>
						<Tabs
							value={tabValue}
							onChange={this.handleTabChange.bind(this)}
							classes={{ indicator: classes.tabIndicator }}
						>
							<Tab
								classes={{
									root: classes.tabRoot,
									labelContainer: classes.tabLabelContainer
								}}
								label="Course"
								value="course"
								disableRipple
							/>
							<Tab
								classes={{
									root: classes.tabRoot,
									labelContainer: classes.tabLabelContainer
								}}
								label="Content"
								value="content"
								disableRipple
							/>
						</Tabs>
					</Grid>

					{_.isEqual(tabValue, 'content') && (
						<Grid item xs={12} md={10} >
							{_.map(contentTags, (contentTag, index) => _.includes(_.toLower(contentTag.name), _.toLower(searchValue)) && (
								<div className={"ctClass"}>
									<TagInfoCard isTooltip={showTooltip} onMouseOut={this.handleHover.bind(this)} onHover={this.handleHover.bind(this)} key={`${contentTag._id} ${index}`} tagInfo={contentTag} onEditClick={this.handleEditTagFormDialogOpen.bind(this)} />
								</div>

							))}
						</Grid>
					)}
					{_.isEqual(tabValue, 'course') && (
						<Grid item xs={12} md={10}>
							{_.map(courseTags, (courseTag, index) => _.includes(_.toLower(courseTag.name), _.toLower(searchValue)) && (
								<div className={"crsClass"}>
									<TagInfoCard isTooltip={showTooltip} onMouseOut={this.handleHover.bind(this)} onHover={this.handleHover.bind(this)} key={`${courseTag._id} ${index}`} tagInfo={courseTag} onEditClick={this.handleEditTagFormDialogOpen.bind(this)} />
								</div>
							))}
						</Grid>
					)}
				</Grid>
				<MyPATDialog
					dialogHeading='Add Custom Tags'
					dialogOpen={tagTypeDialogOpen}
					customButtonVariant="withoutBorderCloseIcon"
					otherDialogProps={otherDialogProps}
					dialogHasActions={false}
					onDialogClose={this.handleTagTypeDialogClose.bind(this)}
					isAlignCenter={true}
				>
					{_.map(contentTagTypes, (type, index) => (
						<Card key={`${type._id} ${index}`} className={[classes.mb1x, classes.card].join(' ')}>
							<CardContent className={classes.cardContent}>
								<Grid container alignItems="center">
									<Grid item xs={2} className={classes.mr2x}>
										<TagPreview tagType={type.type} />
									</Grid>

									<Grid item xs zeroMinWidth>
										<Typography variant="h6" className={classes.tagTitle} noWrap>{type.title}</Typography>
										<Typography variant="subtitle1" className={classes.subtitleFont} noWrap>{type.description}</Typography>
									</Grid>

									<Grid item xs={2} className={classes.textRight}>
										<Button
											variant="outlined"
											className={classes.addTagBtn}
											onClick={this.handleAddTagFormDialogOpen.bind(this, type.type, type.title)}
										>
											Add Tag
                  </Button>
									</Grid>
								</Grid>
							</CardContent>
						</Card>
					))}
				</MyPATDialog>

				<MyPATDialog
					dialogHeading={tagFormData.typeName || 'Update Tag'}
					dialogOpen={tagFormDialogOpen}
					otherDialogProps={otherDialogProps}
					customButtonVariant="withoutBorderCloseIcon"
					onDialogClose={this.handleAddTagFormDialogClose.bind(this)}
					onDialogBack={edit ? undefined : this.handleAddTagFormDialogClose.bind(this)}
					onDialogSave={this.handleAddTagFormSave.bind(this)}
					onDialogCancel={this.handleAddTagFormDialogClose.bind(this)}
					isAlignCenter={true}
				>
					<Card className={[classes.mb1x, classes.marginSM, classes.cardContainer].join(' ')}  elevation={0}>
						<CardContent className={classes.cardContentRoot}>
							<Typography variant="h6" className={[classes.mb1x, classes.contentHeading].join(' ')}>Tag Detail</Typography>

							<Grid container alignItems="center">
								<Grid item xs={12} className={classes.mb1x}>
									<Typography variant="body1">Name * <span style={{ fontSize: '10px', color: 'red' }}> {this.state.tagNameError} </span></Typography>
									<MyPATTextField
										inputId="name"
										name="name"
										placeholder="Enter Name"
										required={true}
										helperText="This name show as tag name"
										value={tagFormData.name || ''}
										onChange={this.handleTagFormInputChange.bind(this)}
										fullWidthControl
									/>
								</Grid>
							</Grid>

							<Grid container alignItems="center">
								<Grid item md={6} className={classes.mb1x}>
									<Typography variant="body1">Tag For</Typography>
									<RadioGroup
										name='tagFormFor'
										defaultValue='course'
										value={isTagForTypeContent ? 'content' : 'course'}
										onChange={this.handleTagFormForChange.bind(this)}
										row
									>
										<FormControlLabel
											control={<Radio color="primary" />}
											label='Course'
											value='course'
										/>
										<FormControlLabel
											control={<Radio color="primary" />}
											label='Content'
											value='content'
										/>
									</RadioGroup>
								</Grid>

								<Grid item md={6} className={classes.mb1x}>
									<Typography variant="body1">Tag Should</Typography>
									<RadioGroup
										name="tagShould"
										defaultValue={ACLService.checkModulePermission("tag", "createMandatory") ? "mandatory" : "optional"}
										value={tagFormData.isCompulsory && ACLService.checkModulePermission("tag", "createMandatory") ? 'mandatory' : 'optional'}
										onChange={this.handleTagShouldChange.bind(this)}
										row
									>
								{ACLService.checkModulePermission("tag", "createMandatory") && 
										<FormControlLabel
											control={<Radio color="primary" />}
											label="Mandatory"
											value="mandatory"
										/>
					            }
										<FormControlLabel
											control={<Radio color="primary" />}
											label="Optional"
											value="optional"
										/>
									</RadioGroup>
								</Grid>

								{isTagForTypeContent && (
									<Grid item xs={12}>
										<Typography variant="body1">Select Content Type</Typography>
										<FormGroup row>
											{_.map(contentTypes, (contentType, index) => (
												<FormControlLabel
													key={`contentType-${index}`}
													control={<Checkbox color="primary" />}
													label={contentType.name}
													value={contentType.code}
													checked={_.includes(tagFormData.contentTypes, contentType.code)}
													onChange={this.handleContentTypeChange.bind(this, contentType.code)}
												/>
											))}
										</FormGroup>
									</Grid>
								)}
							</Grid>

							<Grid container alignItems="center">
								{_.includes(['datepicker'], tagFormData.content.type) && (
									<Grid item className={classes.mb1x}>
										<Typography variant="body1">Preview</Typography>
										<TagPreview style="width: 'fit-content'" tagType={tagFormData.content.type} />
									</Grid>
								)}

								{_.includes(['searchDropdown','listpickerMultiselect', 'listpicker', 'checkboxOptions', 'radioOptions'], tagFormData.content.type) && (
									<Grid item xs={12} className={classes.mb1x}>
										<Typography variant="body1">Options</Typography>
										<Grid container alignItems="flex-start">
											<Grid item xs="auto">
												<MyPATTextField
													type="number"
													name="data"
													min="1"
													className={classes.optionLength}
													value={dataLength}
													onChange={this.handleTagFormOptionsChange.bind(this)}
												/>
											</Grid>
											<Grid item xs>
												<FormGroup row>
													{getTextFields(dataLength)}
												</FormGroup>
											</Grid>
										</Grid>
									</Grid>
								)}

								{_.includes(['text', 'textLonginput'], tagFormData.content.type) && (
									<Grid item xs={12} className={classes.mb1x}>
										<Typography variant="body1">Character Limit</Typography>
										<FormGroup row>
											<MyPATTextField
												type="number"
												name="data"
												className={classes.optionLength}
												value={tagFormData.content.textLength || 50}
												onChange={this.handleTagFormTextLengthChange.bind(this)}
											/>
										</FormGroup>
									</Grid>
								)}


								<Grid item xs={12} className={classes.mb1x}>
									<Typography variant="body1">Description</Typography>
									<MyPATTextArea
										inputId="desc"
										name="desc"
										placeholder="Write here..."
										rows="3"
										value={tagFormData.desc || ''}
										onChange={this.handleTagFormInputChange.bind(this)}
										multiline
										fullWidthControl
									/>
								</Grid>
							</Grid>
						</CardContent>
					</Card>
				</MyPATDialog>
			</>
		);
	}
}

const mapStateToProps = (state: any) => ({
	contentTagTypes: _.get(state, 'tagManagementData.contentTags.tagTypes', []),
	courseTagTypes: _.get(state, 'tagManagementData.courseTags.tagTypes', []),
	contentTags: _.get(state, 'tagManagementData.contentTags.list', []),
	courseTags: _.get(state, 'tagManagementData.courseTags.list', []),
	contentTypes: _.get(state, 'tagManagementData.contentType.list', []),
	showLicenseExpiredDialog:  state.loginData.userData &&  state.loginData.userData.showLicenseExpiredDialog,
	isPostExpiryDays:  state.loginData.userData &&  state.loginData.userData.isPostExpiryDays
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
	contentTagTypesList: ContentTagsActions.contentTagTypesList,
	courseTagTypesList: CourseTagsActions.courseTagTypesList,
	contentTagsList: ContentTagsActions.contentTagsList,
	courseTagsList: CourseTagsActions.courseTagsList,
	contentTypeList: ContentTypeActions.list,
	toggleLicenseExpiredDialog,
	setLoggedInUser
}, dispatch);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TagManagementContainer));